import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { MasterOperatorSingleSettings } from '../master-operator-single/master-operator-single-settings';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';
import { MasterOperatorWorkspace } from '../models/master-operator-workspace';

const COMPONENT_SELECTOR = 'tc-master-operator-realtime-connect-popup.component';
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-realtime-connect-popup.component.html',
    styleUrls: ['./master-operator-realtime-connect-popup.component.scss'],
    standalone: false
})
export class MasterOperatorRealtimeConnectPopup implements OnInit {
  T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;
  masterOperatorConnectSettings: MasterOperatorRealtimeConnectPopupConfiguration;
  masterInstanceIds: string[];

  model: MasterOperatorWorkspace;
  configuration: MasterOperatorConnectItemsSettings;
  isValid: boolean;

  constructor(
    private dialogRef: MatDialogRef<MasterOperatorRealtimeConnectPopup>,
    @Inject(MAT_DIALOG_DATA) parameters: MasterOperatorRealtimeConnectPopupConfiguration
  ) {
    this.masterOperatorConnectSettings = parameters;
    this.configuration = parameters.settings.connect;
  }

  ngOnInit(): void {}

  cancel(_) {
    this.dialogRef.close(false);
  }

  connect() {
    const configuration = globalUtilsHelper.clone(
      this.masterOperatorConnectSettings.settings,
      true
    );
    configuration.connect.items = this.model.masterConnectItemsSettings.items;
    this.dialogRef.close(configuration);
  }

  onConfigured(configuration: MasterOperatorWorkspace) {
    this.model = configuration;
  }

  onValidChanged(isValid: boolean) {
    this.isValid = isValid;
  }

  onButtonClose(_) {
    this.dialogRef.close(this.configuration);
  }
}

export class MasterOperatorRealtimeConnectPopupConfiguration {
  settings: MasterOperatorSingleSettings;

  constructor(init: Partial<MasterOperatorRealtimeConnectPopupConfiguration>) {
    Object.assign(this, init);
  }
}
